import { api } from './client'
import type { CreateProjectRequest, ListProjectsQuery, Project, UUID } from '@/types/api'

function compactQuery(query?: ListProjectsQuery): ListProjectsQuery | undefined {
  if (!query) return undefined
  const out: ListProjectsQuery = {}
  if (query.id?.trim()) out.id = query.id.trim()
  if (query.pid != null) out.pid = query.pid
  if (query.shop_type_id != null) out.shop_type_id = query.shop_type_id
  if (query.chain_brand_id != null) out.chain_brand_id = query.chain_brand_id
  if (query.inventory_mould_id != null) out.inventory_mould_id = query.inventory_mould_id
  if (query.inventory_id != null) out.inventory_id = query.inventory_id
  return Object.keys(out).length ? out : undefined
}

export const projectsApi = {
  list: async (query?: ListProjectsQuery): Promise<Project[]> =>
    (await api.get('/projects', { params: compactQuery(query) })).data,

  get: async (id: UUID): Promise<Project> => (await api.get(`/projects/${id}`)).data,

  create: async (body: CreateProjectRequest): Promise<Project> =>
    (await api.post('/projects', body)).data,

  updateParams: async (
    id: UUID,
    param_overrides: Record<string, number | string>,
  ): Promise<Project> =>
    (await api.put(`/projects/${id}/params`, { param_overrides })).data,
}
